import { defineMessages } from 'react-intl';

export default defineMessages({
    download: {
        id: '_.ui.download_button',
        defaultMessage: 'Download'
    }
});
